export default __webpack_public_path__ + "static/banner-one-main-img-6dc0ead7b5ac08dcc5aab4a2b969ca5d.png";